import { FieldType } from "../api.js";
import { BaseModelConvertSpec } from "./base.specs.js";
const ReferralRewardStatusSpecs = {
  dailyFreeSetting: {
    lastDailyRefTokenClaimedAt: FieldType.DateTime,
    currentPeriodResetDate: FieldType.DateTime,
    nextPeriodResetDate: FieldType.DateTime
  }
};
const ReferralBonusTokenModelSpecs = {
  ...BaseModelConvertSpec,
  tokenAmt: FieldType.BigNumber,
  confirmedAt: FieldType.DateTime,
  redeemedAt: FieldType.DateTime
};
const ReferralRewardEventModelSpecs = {
  tokenCount: FieldType.BigNumber,
  confirmedAt: FieldType.DateTime,
  totalTokenAmt: FieldType.BigNumber
};
export {
  ReferralBonusTokenModelSpecs,
  ReferralRewardEventModelSpecs,
  ReferralRewardStatusSpecs
};
